module.exports = __webpack_public_path__ + "f095393b158718c043eff5b14a68fc80.ttf";